import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobEmailTemplate.Save.IRequest;
type Response = Api.Core.ClaimJobEmailTemplate.Save.IResponse;
type Headers = Api.Core.ClaimJobEmailTemplate.Save.IHeaders;
const url = '/api/Management/ClaimJobEmailTemplate';
export default async function claimJobEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
